export default "/Frontend/dist/pdf.0e57ba610246a56ff98cd272cc1f0165.svg";